module.exports = __webpack_public_path__ + "fonts/Roboto-MediumItalic.cabdb4a1.ttf";